import { previewLanguage } from "@/lib/previewLanguage";

// The app language saved on this device at each sign-in, so sign-in and sign-up open in
// it next time (English on a first visit). In an Admin → Responsive Preview window the
// preview's language is used instead and nothing is saved (product owner, 2026-11-03).
const SUPPORTED_LAUNCH_LOCALES = new Set(["en", "fr-CA", "es-419", "pt-BR"]);
const LAUNCH_LOCALE_COOKIE = "lm_app_locale";
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export function normalizeLaunchLocale(locale) {
  if (SUPPORTED_LAUNCH_LOCALES.has(locale)) return locale;
  if (typeof locale === "string") {
    const lower = locale.toLowerCase();
    if (lower.startsWith("fr")) return "fr-CA";
    if (lower.startsWith("es")) return "es-419";
    if (lower.startsWith("pt")) return "pt-BR";
  }
  return "en";
}

export function rememberLaunchLocaleCookie(locale) {
  if (typeof document === "undefined" || previewLanguage()) return;
  const normalized = normalizeLaunchLocale(locale);
  const secure = typeof window !== "undefined" && window.location?.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${LAUNCH_LOCALE_COOKIE}=${encodeURIComponent(normalized)}; Max-Age=${COOKIE_MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secure}`;
}

export function getLaunchLocaleFromCookie() {
  const preview = previewLanguage();
  if (preview) return preview;
  if (typeof document === "undefined") return "en";
  const prefix = `${LAUNCH_LOCALE_COOKIE}=`;
  const cookie = document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix));

  if (!cookie) return "en";

  try {
    return normalizeLaunchLocale(decodeURIComponent(cookie.slice(prefix.length)));
  } catch {
    return "en";
  }
}
